import { APPOINTMENT_ROUTE } from '@web-app/components/consts';
import { useNotifications } from '@web-app/hooks/queries/notifications';
import { useRouter } from 'next/router';

import { NotificationBanner } from './NotificationBanner';

// Map pathname to area name for notification filtering
const PATH_TO_AREA: Record<string, string> = {
  [APPOINTMENT_ROUTE]: 'home',
};

export const NotificationContainer = () => {
  const router = useRouter();
  const { data: notifications, isLoading } = useNotifications();

  const currentArea = PATH_TO_AREA[router.pathname];

  // Don't render if current page is not in the mapping
  if (!currentArea) {
    return null;
  }

  if (isLoading || !notifications?.length) {
    return null;
  }

  // Filter notifications that include current area
  const filteredNotifications = notifications.filter(
    (n) => n.area.length === 0 || n.area.includes(currentArea),
  );

  if (!filteredNotifications.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {filteredNotifications.map((notification) => (
        <NotificationBanner key={notification.id} notification={notification} />
      ))}
    </div>
  );
};
